import { createEntityAdapter } from '@reduxjs/toolkit';

import type { IFileItem } from 'api/files/types';

export const filesItemsAdapter = createEntityAdapter<IFileItem>({
  selectId: (item) => item.src?.id as string,
});

export const selectors = filesItemsAdapter.getSelectors();
